// SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

import { GlobalStateService } from './global.service.js';

const prefix = '@nve: ';

export class LogService {
  static log(value: string, ...args: unknown[]) {
    if (GlobalStateService.state.env !== 'production') {
      console.log(`${prefix}${value}`, ...args);
    }
  }

  static warn(value: string, ...args: unknown[]) {
    if (GlobalStateService.state.env !== 'production') {
      console.warn(`${prefix}${value}`, ...args);
      this.#dispatch('warn', value, ...args);
    }
  }

  static error(value: string, ...args: unknown[]) {
    if (GlobalStateService.state.env !== 'production') {
      console.error(`${prefix}${value}`, ...args);
      this.#dispatch('error', value, ...args);
    }
  }

  static #dispatch(type: 'warn' | 'error', value: string, ...args: unknown[]) {
    globalThis.document.dispatchEvent(new CustomEvent('NVE_ELEMENTS_LOG', { detail: { type, value, args } }));
  }
}
